var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPersonOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#72383D;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-696 -9)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(696 9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.289,12.289A4.145,4.145,0,1,0,8.145,8.145,4.144,4.144,0,0,0,12.289,12.289Zm0,2.072C9.523,14.362,4,15.75,4,18.507v2.072H20.579V18.507C20.579,15.75,15.056,14.362,12.289,14.362Z",
    transform: "translate(692.711 6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonOn);
export default __webpack_public_path__ + "static/media/icon_person_on.9f4beae9607e7564cbbf5550e9d6a7cb.svg";
export { ForwardRef as ReactComponent };